export interface SimpleModeState {
    simpleMode: boolean;
  }
  
  export const initialState: SimpleModeState = {
    simpleMode: true, // Default to condensed mode for new users
  };